/***
 * @file:ç»å½
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
// import { RouteReuseService } from '@ithinkdt/core';

import { SettingsService } from '@ithinkdt/shared/browser';
import { I18NService } from '@ithinkdt/shared/i18n';
import { COMMON_COMFIG } from '@ithinkdt/shared/utils';

import { AuthFetchService } from '../fetch/service/auth.service';
import { HandleLoginService } from '../handle-login.service';

@Component({
  selector: 'dt-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  // host        : {
  //   '[style.background]' : `pagesConfig['loginBg'] || '#ccc'`
  // }
})
export class LoginComponent implements OnInit {
  pagesConfig: any;
  themeConfig: any;
  envConfig: any;
  backgroundImage: SafeStyle;
  // è´¦å·å¯ç è¡¨å
  form: FormGroup;
  // æ¯å¦æäº¤ç¶æ
  isSubmiting = false;
  langs: any[];

  constructor(
    private fb: FormBuilder,
    private settingsSrv: SettingsService,
    // private routeReuse: RouteReuseService,
    private i18n: I18NService,
    private authFetchSrv: AuthFetchService,
    private handleLoginSrv: HandleLoginService,
    private sanitizer: DomSanitizer
  ) {
    this.pagesConfig = this.settingsSrv.userConfig['pages'] || {};
    this.themeConfig = this.settingsSrv.userConfig['theme'] || {};
    this.envConfig = this.settingsSrv.userConfig['env'] || {};

    this.checkSsoLogin();
    this.backgroundImage = this.safeStyle(this.pagesConfig['loginBg']) || '#ccc';
    this.langs = this.i18n.getLangs();
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      userName: [null, [Validators.required]],
      password: [null, [Validators.required]],
    });
    // console.log(this.form);
  }

  checkSsoLogin() {
    if (this.pagesConfig['ssoLogin']) {
      this.settingsSrv.resetSettings();
      let ssoLoginUrl = this.envConfig['ssoLoginUrl'] || 'http://sso.qa.ithinkdt.com';
      const redirectUrl = this.pagesConfig['redirectUrl'] || COMMON_COMFIG.HOME_URL;
      const baseFref = this.pagesConfig['baseHref'] || '';
      // useHistoryRouter æ¯å¦ä½¿ç¨historyæ¨¡å¼è·¯ç±
      const hashStr = this.pagesConfig['useHistoryRouter'] ? '' : '/#';

      const redirectUri = encodeURIComponent(`${window.location.origin}${baseFref}${hashStr}${redirectUrl}`);

      ssoLoginUrl += `?redirect_uri=${redirectUri}`;
      window.location.href = ssoLoginUrl;
      // console.log('window.location.origin', window.location.origin);
      // console.log('redirectUri', decodeURIComponent(redirectUri));

      // window.open(ssoLoginUrl, '_self');
    }
  }

  safeStyle(url) {
    // ç¬¬ä¸ç§ä¸è¡
    // return this.sanitizer.bypassSecurityTrustStyle(`'url(${url})'`);
    return this.sanitizer.bypassSecurityTrustStyle('url(' + url + ')');
  }

  // ç»å½æé®
  submit(): void {
    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (this.form.valid) {
      const { userName, password } = this.form.value;
      const param = {
        username: userName,
        password,
      };
      this.login(param);
    }
  }

  // è·åloginä¿¡æ¯
  login(param) {
    this.settingsSrv.resetSettings();
    // this.routeReuse.deleteAllRouteSnapshot();
    this.isSubmiting = true;
    this.authFetchSrv.login(param).subscribe((res) => {
      if (res.status) {
        this.handleLoginSrv.setToken(res.data);
      }
      this.isSubmiting = false;
    });
  }

  change(lang: string) {
    this.i18n.use(lang);
    this.settingsSrv.setLayout('lang', lang);
  }
}
